/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
  Type,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { FollowService } from 'app/services/follow.service';
import { InsightsSectionComponent } from './insights-section.component';
import { LabelValue } from 'app/models/LabeLValue';

@Component({
  selector: 'app-insights-section-container',
  template: ` <template #container></template> `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InsightsSectionContainerComponent
  implements AfterViewInit, OnChanges
{
  @Input() sectionTitle: string;
  @Input() appId: string;
  @Input() appName: string;
  @Input() data: any; // TODO: must update to proper types
  @Input() type: string;
  @Input() os: string;
  @Input() device: string;
  @Input() region: string;
  @Input() month: string;
  @Input() isFreemium: boolean;
  @Input() isAnonymous: boolean;
  @Input() includeAppSpoofing: boolean;
  @Input() selectedCountry: LabelValue;
  @Input() widgetComponent: Type<InsightsSectionComponent>;
  @Input() swiperControls: TemplateRef<any>;

  @Output() toAppDiscovery: EventEmitter<any> = new EventEmitter<any>();
  @Output() followButtonBreakpointReached: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() followButtonClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() anchorClick = new EventEmitter<string>();

  @ViewChild('container', { read: ViewContainerRef })
  container: ViewContainerRef;

  instance: any;

  constructor(
    private _componentFactoryResolver: ComponentFactoryResolver,
    private _changeDetector: ChangeDetectorRef,
    private _followService: FollowService
  ) {}

  ngAfterViewInit(): void {
    this.container.clear();
    const componentFactory =
      this._componentFactoryResolver.resolveComponentFactory<InsightsSectionComponent>(
        this.widgetComponent
      );
    const componentRef = this.container.createComponent(componentFactory);
    const instance = componentRef.instance;
    instance.sectionTitle = this.sectionTitle;
    instance.appId = this.appId;
    instance.appName = this.appName;
    instance.data = this.data; // TODO: must update to proper types
    instance.type = this.type;
    instance.os = this.os;
    instance.device = this.device;
    instance.region = this.region;
    instance.month = this.month;
    instance.isFreemium = this.isFreemium;
    instance.isAnonymous = this.isAnonymous;
    instance.selectedCountry = this.selectedCountry;
    instance.includeAppSpoofing = this.includeAppSpoofing;
    instance.swiperControls = this.swiperControls;

    instance.toAppDiscovery.subscribe(event => {
      this.toAppDiscovery.emit(event);
    });

    instance.followButtonBreakpointReached.subscribe(event => {
      this.followButtonBreakpointReached.emit(event);
    });

    instance.followButtonClick.subscribe(event => {
      this.followButtonClick.emit(event);
    });

    instance.anchorClick.subscribe(event => {
      this.anchorClick.emit(event);
    });

    this._followService.isProcessingFollow$.subscribe(value => {
      instance.processing = value;
      instance.processingFollow = value;
      instance._changeDetector.detectChanges();
    });

    this._followService.isFollowing$.subscribe(value => {
      instance.isFollowing = value;
      instance._changeDetector.detectChanges();
    });

    this._followService.numWatching$.subscribe(value => {
      instance.numWatching = value;
      instance._changeDetector.detectChanges();
    });

    this.instance = componentRef.instance;

    this._changeDetector.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.instance) {
      Object.keys(changes).forEach(key => {
        this.instance[key] = this[key];
      });
      this.instance._changeDetector.detectChanges();
    }
  }
}
